<template>
  <div class="records-list">
    <loadSpinner v-if="loading" />
    <div id="intro">
      <h1>{{ title }}</h1>
      <p>{{ description }}</p>
      <p>
        <a :href="this.$store.state.urlToTradera" target="_blank" class="button tradera">Gå till alla traderaauktioner</a>
      </p>
    </div>
    <div v-if="records.length !== 0" id="search_records_container">
        <input type="text" ref="searchValue" placeholder="Sök skiva.." v-model="searchValue">
    </div>
    <div v-if="records.length === 0" id="intro">
      <p>Det finns inga skivor inlagda just nu.. Välkommen åter!</p>
    </div>
    <ul>
      <li class="record-container" v-for="(record, index) in filteredRecords" :key="index">
        <div class="thumbnail">
          <img :src="record.thumb">
        </div>
          <div class="title-container">
            <p><b>{{ record.title }}</b></p>
            <span class="tradera-link"><a :href="record.link" target="_blank">Gå till annons »</a></span>
          </div>
          <div class="playbutton-container" v-if="record.twoSides">                      
              <mp3player class="mp3-player" :src="'http://www.hotspinrecords.com/skivor/' + record.songNumber + '.mp3'" title="test1" mode="mini" :ui="{icons:{play:'fa-play-circle'}, labels:{play: 'Sida 1', pause: 'Paus'}, classes:{btn:'play-icon'}}  "></mp3player>
              <mp3player class="mp3-player" :src="'http://www.hotspinrecords.com/skivor/' + record.songNumber + 'b.mp3'" title="test1" mode="mini" :ui="{icons:{play:'fa-play-circle'}, labels:{play: 'Sida 2', pause: 'Paus'}, classes:{btn:'play-icon'}}  "></mp3player>
          </div>

          <div class="playbutton-container" v-else>                      
            <span class="ubaplayer-controls button-play">
              <mp3player class="mp3-player" :src="'http://www.hotspinrecords.com/skivor/' + record.songNumber + '.mp3'" title="test1" mode="mini" :ui="{icons:{play:'fa-play-circle'}, labels:{play: 'Lyssna', pause: 'Paus'}, classes:{btn:'play-icon'}}  "></mp3player>
              <!--<a class="ubaplayer-button button" :href="'http://www.hotspinrecords.com/skivor/' + record.number + '.mp3'">Lyssna</a>-->
            </span>
          </div>

        </li>
    </ul>
  </div>
</template>

<script>

import db from '@/Firebase/init'
import loadSpinner from '@/components/LoadingSpinner'
import mp3player from 'vue2-mp3-player'

export default {
  name: 'recordsList',

  components: {
    loadSpinner,
    mp3player
  },

  data () {
    return {
      loading: true,
      searchValue: '',
      title: 'Auktioner på Tradera',
      description: 'Här kan ni provlyssna på skivorna som ligger uppe på Tradera',
      records: []
    }
  },

  created() {
    db.collection('autoRecords').orderBy('order').onSnapshot((snapshot) => {
      this.records = []

      snapshot.forEach((doc) => {
        let record = doc.data()
        record.id = doc.id

        this.records.push(record)
      })

      this.loading = false
    })
  },

  computed: {
    filteredRecords() {
      return this.records.filter((record) => {
        const newTitle = record.title.toLowerCase()
        return newTitle.match(this.searchValue.toLowerCase())
      })
    }
  }
}
</script>

<style>
  #intro {
    text-align: center;
  }

  .button {
    display: inline-block;
    background: #ffcf3c;
    color: #2d3742;
    padding: 10px 15px;
    text-decoration: none;
    border-radius: 4px;
    margin: 15px 0 15px;
    box-sizing: border-box;
    min-width: 102px;
  }

  .button:hover,
  .button:focus {
    color: #2d3742;
    background: #F0BD20;
  }

  /* Searchbox */

  #search_records_container {
    background: #eff0f1;
    padding: 10px;
  }

  #search_records_container input {
    display: block;
    width: 100%;
    border: 1px solid #dadada;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
  }

  /* Recordslist */

  ul {
    padding: 0;
  }

  li {
    transition: 0.45s;
    -webkit-transition: 0.45s;
    -moz-transition: 0.45s;
    -ms-transition: 0.45s;
    -o-transition: 0.45s;
  }
  li:hover {
    background: #f5f6f7;
  }

  .record-container {
    border-bottom: 1px solid #dadada;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
  }

  .thumbnail {
    margin-right: 10px;
  }

  .title-container p {
    text-transform: capitalize;
    margin: 0;
  }

  .tradera-link a {
    display: block;
    background: #fafafa;
    color: #999;
    padding: 5px;
    border-radius: 10px;
    font-size: 12px;
    margin-top: 5px;
  }

  .playbutton-container {
    display: flex;
    justify-content: space-between;
    margin-left: auto;
  }

  .button-play {
    display: flex;
    align-items: center;
  }

  /* Player */

#ubaplayer-fallback {
	display: none;
}

.ubaplayer-button {
	background: url('./../assets/play.png') no-repeat 0 0;
	display: block;
	cursor: pointer;
	margin: 0;
	padding: 10px 10px 10px 25px;
	position: relative;
}

.ubaplayer-button:hover {
	background-position: 0;
}

.ubaplayer-button.ubaplayer-playing {
	background: url('./../assets/pause.png') no-repeat 0 0;
	background-position: 0;
	color: red;

}

.ubaplayer-button.ubaplayer-playing:hover {
	background-position: 0;
	color: red;
}

.ubaplayer-button.ubaplayer-loading:after,
.ubaplayer-button.ubaplayer-loading:hover:after {
	/*background: url("img/loading.gif") no-repeat 0 7px;*/
	content: " ";
	height: 28px;
	left: 0;
	position: absolute;
	text-indent: 0!important;
	top: 0;
	width: 20px;
}

#ubaplayer {
	display: none;
}

.ubaplayer-button {
	background-position: 0;
	background-size: 16px 16px;
}

.ubaplayer-button:hover {
	background-position: 0;
}

.ubaplayer-button.playing {
	background-position: 0;
	color: red;
}

.ubaplayer-button.playing:hover {
	background-position: 0;
	color: red;

}

/* PLAY ICON */

  a {
    text-decoration: none;
  }

  .mp3-player + .mp3-player {
    margin-left: 10px;
  }

  .play-icon {
    font-size: 11px;
    background: #2D3742;
    color: #fff;
    padding: 6px 10px;
    border-radius: 60px;
    text-decoration: none;
  }

  .play-icon i {
    font-size: 11px;
  }

  .play-icon:hover {
    background: #445364;
  }

@media screen and (max-width: 400px) {

	body {
		padding: 10px;
	}

	.record-container {
		flex-direction: column;
		text-align: center;
	}

	#search_records_form input {
		font-size: 16px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/RecordsList.vue